import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { API_BASE_URL } from '../api/client';
import { HealthPill } from './HealthPill';

function navLinkClass({ isActive }: { isActive: boolean }): string {
  return isActive ? 'nav__link nav__link--active' : 'nav__link';
}

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="app">
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <header className="app__header">
        <div className="app__header-inner">
          <div className="brand">
            <span className="brand__mark" aria-hidden="true">
              R
            </span>
            <span className="brand__text">
              <span className="brand__name">Relay</span>
              <span className="brand__tagline">Webhook delivery</span>
            </span>
          </div>

          <nav className="nav" aria-label="Primary">
            <NavLink to="/" end className={navLinkClass}>
              Events
            </NavLink>
            <NavLink to="/stats" className={navLinkClass}>
              Stats
            </NavLink>
          </nav>

          <div className="app__health">
            <HealthPill />
          </div>
        </div>
      </header>

      <main id="main" className="app__main">
        {children}
      </main>

      <footer className="app__footer">
        <span>At-least-once delivery with retries, backoff, and dead-letter queuing.</span>
        <span className="app__api mono" title="Set with VITE_API_BASE_URL at build time">
          API {API_BASE_URL}
        </span>
      </footer>
    </div>
  );
}
